module.exports = __webpack_public_path__ + "TarunReddi-6da2e832.webp";